export default __webpack_public_path__ + "static/media/mapFrameExplorerEN.a005cd62.jpg";